import React from "react";
import "./WhereWeWork.css";

const LOCATIONS = [
  {
    city: "London",
    address: "128 CITY ROAD, London, EC1V 2NX United Kingdom,",
    image:
      "https://images.unsplash.com/photo-1505761671935-60b3a7427bad?auto=format&fit=crop&w=1200&q=80"
  },
  {
    city: "Tennessee",
    address: "522 Aventura Dr, Mt Juliet, Tennessee 37122 United States",
    image:
      "https://media.istockphoto.com/id/538811669/photo/manhattan-panorama-with-its-skyscrapers-illuminated-at-dusk-new-york.webp?a=1&b=1&s=612x612&w=0&k=20&c=4Rj4Mx2RjMYeOHuNAs7ZWupwdao25kf81tpZ1Kr6TqM="
  },
  {
    city: "Bengaluru",
    address: "Embassy Golf Links Business Park, Bengaluru, Karnataka",
    image:
      "https://images.unsplash.com/photo-1697130383976-38f28c444292?w=700&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8YmFuZ2Fsb3JlfGVufDB8fDB8fHww"
  },
  {
    city: "Chennai",
    address: "Primus Building, Door No. SP – 7A, Guindy Chennai, Tamil Nadu",
    image:
      "https://media.istockphoto.com/id/1226340114/photo/puratchi-thalaivar-dr-mgr-central-railway-station-chennai-central-railway-station-india.webp?a=1&b=1&s=612x612&w=0&k=20&c=TF2BSVQw25WtC5YsF1WPukWmXCaEgLDWNlCvaTQxsNQ="
  },
  {
    city: "Pasuvanthanai",
    address: "Rajeev Nagar, Pasuvanthanai, Thoothukudi, Tamil Nadu",
    image:
      "https://images.unsplash.com/photo-1528728329032-2972f65dfb3f?auto=format&fit=crop&w=1200&q=80"
  },
  {
    city: "Anywhere",
    address: "Work remotely from anywhere",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80"
  }
];

const WhereWeWork = () => {
  return (
    <section className="www-wrapper">
      <div className="www-header">
        <h2>Where <span>we</span> work</h2>
        <p>
          Hybrid work is how we do things — but you can find our teams at offices
          across the globe.
        </p>
      </div>

      <div className="www-grid">
        {LOCATIONS.map((item, index) => (
          <div className="www-card" key={index}>
            <img src={item.image} alt={item.city} />
            <div className="www-overlay">
              <h3>{item.city}</h3>
              <span>{item.address}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhereWeWork;
